import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { StickyHeaderNavigationCentered } from '@/components/StickyHeaderNavigationCentered'
import { useSavingsStore } from '@/store/useSavingsStore'

export const FirstDepositHeader: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const savingGoalId = useSavingsStore(
    (state) => state.goalTransferIn?.saving_goal_id,
  )

  const handleSkip = () => {
    // Навигация на страницу деталей цели (как в React Native)
    if (savingGoalId) {
      navigate(`/savings/savings-detail/${savingGoalId}`)
    } else {
      // Если нет ID цели, переходим на главную страницу сбережений
      navigate('/savings')
    }
  }

  return (
    <StickyHeaderNavigationCentered
      title={t('translation:goal.makeYourFirstDeposit')}
      showBackButton={false}
      rightIcon={
        <BaseView
          onClick={handleSkip}
          style={{
            cursor: 'pointer',
            padding: '8px 12px',
            borderRadius: '8px',
            transition: 'opacity 0.2s ease',
          }}
          className="hover:opacity-70 active:opacity-50"
        >
          <BaseText fontSize={16} fontFamily="semibold" color="label.clickable">
            {t('translation:skip')}
          </BaseText>
        </BaseView>
      }
    />
  )
}
